import React, {useEffect, useCallback} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import FormPanel from '../../../components/FormPanel';
import useMe from '../../../hooks/useMe';
import GradientHeading from '../components/GradientHeading';
import Page from '../components/Page';
import {Button, Center, Progress, Image, Spinner, Text, VStack, chakra} from 'components/ui/chakra';
import {Glum} from 'puddleglum';
import assetUrl from 'utils/assetUrl';

function Home() {
	const {me, isLoading} = useMe();
	const navigate = useNavigate();

	const routeToPortal = useCallback(
		(userRoles: Glum.Models.UserRole[]) => {
			if (userRoles?.length === 1) {
				if (userRoles?.find((role) => role.name === 'Admin')) {
					window.location.href = '/admin';
				} else if (userRoles?.find((role) => role.name === 'Provider')) {
					window.location.href = '/provider';
				} else if (userRoles?.find((role) => role.name === 'Employer')) {
					window.location.href = '/employer';
				} else if (userRoles?.find((role) => role.name === 'Patient')) {
					window.location.href = '/patient';
				}
			} else navigate('/select-user-type');
		},
		[navigate],
	);

	useEffect(() => {
		if (!me || !me?.roles) {
			return;
		}

		routeToPortal(me.roles);
	}, [me, routeToPortal]);

	if (isLoading) {
		return <Progress size='xs' isIndeterminate />;
	}

	return (
		<Page>
			<Center minH='100vh' py={{base: 10, md: 16}}>
				<FormPanel
					description='Search, book, and manage care with the same visual language as the public Allora experience.'
					eyebrow='Welcome'
					maxW='32rem'
					w='full'
				>
					<VStack
						align='stretch'
						gap={5}
						style={!isLoading && !me ? {} : {display: 'none'}}
					>
						<Center>
							<Image src={assetUrl('/images/logo.png')} alt='Allora' w='72px' />
						</Center>
						<GradientHeading>Allora Health</GradientHeading>
						<Text color='subtleText' fontSize='sm'>
							Transparent healthcare, elegant workflows, and a calmer experience for
							patients, employers, providers, and pharmacies.
						</Text>
						<Center style={!isLoading ? {display: 'none'} : {}} h='20vh' w='100%'>
							<Spinner size='xl' />
						</Center>
						<Button as={Link} to='login' w='full'>
							Log In
						</Button>
						<Button as={Link} to='signup' w='full' variant='outline'>
							Sign Up
						</Button>
						<Center fontSize='.8em' gap={4} pt={2} w='full'>
							<chakra.a href='/terms' target='_blank'>
								Terms of Service
							</chakra.a>
							<chakra.a
								href='https://www.calvient.com/privacy-policy'
								target='_blank'
							>
								Privacy Policy
							</chakra.a>
						</Center>
					</VStack>
				</FormPanel>
			</Center>
		</Page>
	);
}

export default Home;
